<template>
    <card :noFooterLine="true" class="ticket-card">

        <div slot="image"  class="ticket-card-image" :style="`background-image:url(${image})`">
            <n-button v-if="!deleted" type="danger" class="action-btn" size="sm"  @click.native="cardClick">
                <i slot="label" class="fa fa-times"></i> 
                Cancel Registration
            </n-button>
        </div>

        <div class="ticket-card-header">
            <h6 class="card-category">{{ reg_id }}</h6>
            <h4 class="card-title">{{ programme.title }}</h4>
            <p class="card-description">{{ entryFee }} | Registered on: {{ created }}</p>
        </div>

        <div class="ticket-card-body">
            <p class="bb-line"><small>Event(s) Registered for:</small></p>
            <p v-for="(event, index) in events" :key="index" class="bb-line"><span>{{ event.title }}</span> </p>
        </div>

        <div slot="footer">
            <p class="card-text">Registered on: {{ created }}</p>
        </div>
    </card>
</template>

<script>
import { Card } from 'src/components'
import { Tooltip } from 'element-ui'

export default {
    name: 'TicketCard',
    components: {
        Card,
        [Tooltip.name]: Tooltip,
    },
    props: {
        image: {
            type: String,
            default: "/img/ticket.png",
        },
        title: String,
        department: String,
        slug: String,
        created_at: String,
        price: Number,
        attendance: Boolean,
        deleted: Boolean,
        email: String,
        name: String,
        mobile: String,
        programme: Object,
        events: Array,
        txn_id: String,
        reg_id: String
    },
    computed: {
        entryFee: function (){
            return (this.price > 0) ? `₹ ${this.price}` : `Free Entry`;
        },
        created: function(){
            let date = new Date(this.created_at);
            return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        },
    },
    methods: {
        cardClick(){
            this.$emit('card-click', this.reg_id)
        }
    }
}
</script>

<style lang="scss">

/* Using plain CSS */
@media (max-width: 768px) {
    .ticket-card.long{
        flex-direction: column !important;

        .card-body::after{
            display: none !important;
        }

        .action-btn{
            right: 0px !important;
            bottom: 160px !important;
            font-size: 14px !important;
            padding: 5px 10px !important;
        }
    }
}

.ticket-card{
    
    &.long{
        display: flex;
        flex-direction: row;
        cursor: pointer;
        border-radius: 0.1875rem;
        overflow: hidden;

        .card-image{
            flex: 1;
            transition: all ease-in-out 0.3s;

            .ticket-card-image{
                position: static;
                .action-btn{
                    z-index: 3;
                    right: 10px;
                    bottom: 0px;

                    font-size: 16px;
                    border-radius: 0.1875rem;
                    padding: 10px 15px;
                }
            }
        }

        .card-header,
        .card-body,
        .card-footer{
            flex: 2;
        }

        .card-body{
            padding: 15px;
            padding-left: 30px;
            position: relative;
            transition: all ease-in-out 0.3s;
            z-index: 2;

            &::after{
                content: '';
                position: absolute;
                height: 100%;
                width: 50px;
                background-image: linear-gradient(to right, rgba(255, 0, 0, 0), rgba(255, 255, 255, 1) 50%);
                top: 0;
                left: -50px;
                transition: all ease-in-out 0.3s;
                z-index: 1;
            }
        }

        &:hover > .card-body{
            padding-left: 30px;
        }

        &:hover > .card-body::after{
            // flex: 1.2;
            left: -30px;
        }

        // &:hover > .card-image{
        //     flex: 1.2;
        // }

    }

    .ticket-card-header{
        .card-title{
            margin-top: 0px;
            margin-bottom: 5px;
        }

        .card-category{
            font-size: 1rem;
        }
    }

    .card-footer{
        padding: 10px;
        padding-bottom: 5px;
        margin-top: 10px;
        border-top: solid 1px #eee;
        box-shadow: 0px -2px 5px #eee;
    }

    .ticket-card-body{
        .bb-line{
            color: #353a3e;
            font-weight: normal;
            font-size: 1rem;
        }
    }

    

    .card-footer .status-btns .btn{
        margin-right: 3px;
    }

    .card-header .card-title{
        margin-top: 5px;
        margin-bottom: 0.5rem;
    }

    .ticket-card-header .card-description{
        color: #353a3e;
        font-weight: normal;
    }

    .category, .card-category{
        margin-bottom: 0.2em;
        margin-top: 5px;
    }

    .card-body{
        padding: 15px 15px 15px 15px;
    }

    .progress-container .progress-badge{
        text-transform: initial;
    }

    .description, 
    .card-description, 
    .footer-big p, 
    .footer .stats{
        color: #353a3e;
    }

    .card-image{
        .ticket-card-image{
            height: 200px;
            position: relative;
            text-align: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            box-shadow: inset -1px -5px 5px -3px rgba(0, 0, 0, 0.16);

            .action-btn{
                right: -20px;
                bottom: -25px;
                position: absolute;
                box-shadow: 0px 2px 3px rgba(0,0,0,0.16);
            }

            .card-img-top{
                width: auto;
                height: 200px;
                margin: 0 auto;
                text-align: center;
            }
        }
    }

} 

</style>
